import { createContext } from 'react'

import { SetupPrebidStackSectionContextType } from './types'

export const SetupPrebidStackSectionContext = createContext<SetupPrebidStackSectionContextType>(
  {} as SetupPrebidStackSectionContextType,
)
